<template>
    <SeoHead :seo="seo" />
    <MainLayout>
        <PageHeader title="Тренеры">
            <p class="page-subtitle">
                <template v-if="isFiltered">
                    Отображается {{ filteredMembers.length }} из {{ members.length }} тренеров
                </template>
                <template v-else>{{ members.length }} тренеров</template>
            </p>
        </PageHeader>

        <div class="member-directory-filters">
            <div class="member-directory-filters__row">
                <UiInput
                    v-model="searchQuery"
                    type="search"
                    label="Поиск"
                    placeholder="Имя или команда..."
                    block
                />

                <SeasonSelect
                    v-model="selectedSeason"
                    :seasons="seasons"
                    :multiple="false"
                    include-all
                    block
                    align="left"
                />

                <UiSelect
                    v-if="showTeamFilter"
                    v-model="selectedTeam"
                    label="Команда"
                    :options="[{ value: 'all', label: 'Все' }, ...teamsList.map((team) => ({ value: String(team.id), label: team.name }))]"
                    block
                    align="left"
                    value-type="string"
                />

                <UiSelect
                    v-model="selectedPosition"
                    label="Должность"
                    :options="[{ value: 'all', label: 'Все' }, ...positionsList.map((position) => ({ value: String(position.id), label: position.name }))]"
                    block
                    align="left"
                    value-type="string"
                />

                <UiSelect
                    v-model="selectedNationality"
                    label="Национальность"
                    :options="[{ value: 'all', label: 'Все' }, ...nationalitiesList]"
                    block
                    align="left"
                    value-type="string"
                />
            </div>
        </div>

        <div v-if="displayMembers.length" class="member-poster-grid">
            <MemberPosterCard
                v-for="member in displayMembers"
                :key="member.id"
                :href="member.url"
                :full-name="member.full_name"
                :surname="member.surname"
                :first-name="member.first_name"
                :middle-name="member.middle_name"
                :middle-name-visible="member.middle_name_visible"
                :photo-url="member.photo_url"
                :show-season-meta="showSeasonMeta"
                :team-name="member.team"
                :team-logo-url="member.team_logo_url"
                :team-url="member.team_url"
                :team-short-name="member.team_short_name"
                :number="member.number"
                :position="member.position"
                :status="member.status"
                :primary-color="member.primary_color"
                :secondary-color="member.secondary_color"
            />
        </div>

        <div v-else class="member-directory-empty">
            <p>Тренеры не найдены</p>
        </div>
    </MainLayout>
</template>

<script setup>
import SeoHead from '@/Components/SeoHead.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import PageHeader from '@/components/layout/PageHeader.vue';
import MemberPosterCard from '@/components/directory/MemberPosterCard.vue';
import UiInput from '@/components/ui/forms/UiInput.vue';
import UiSelect from '@/components/ui/forms/UiSelect.vue';
import SeasonSelect from '@/components/filters/SeasonSelect.vue';
import { useMemberDirectory } from '@/composables/useMemberDirectory';

const props = defineProps({
    seo: {
        type: Object,
        default: null,
    },
    members: {
        type: Array,
        default: () => [],
    },
    teams: {
        type: Array,
        default: () => [],
    },
    seasons: {
        type: Array,
        default: () => [],
    },
});

const {
    searchQuery,
    selectedTeam,
    selectedPosition,
    selectedNationality,
    selectedSeason,
    showTeamFilter,
    showSeasonMeta,
    teamsList,
    positionsList,
    nationalitiesList,
    isFiltered,
    filteredMembers,
    displayMembers,
} = useMemberDirectory(props);
</script>
